module.exports = __webpack_public_path__ + "static/media/lend_wbtt.32765e14.svg";